import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getOrderHistory } from '../../apis/orders';
import { DirectoryBar } from '../../components/DirectoryBar';
import { FrontPagination } from '../../components/FrontPagination';
import { H6 } from '../../components/H6';
import { MProductCard } from '../../components/MyPage/MProductCard';
import TrackingNumber from '../../components/MyPage/TrackingNumber';
import { PopUp } from '../../components/PopUp';
import { SearchField } from '../../components/SearchField';
import { OrderSummary } from '../../types/types';
import { orderStatusCase, requestStatusCase } from '../../utils/orderStatus';
import { MyPageStoreTabs } from './MyPageStoreTabs';
import {swapProductShippingStatus} from "../../utils/texts";

export const MyPageOrders = () => {
  const [popup, setPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [orders, setOrders] = useState<OrderSummary[]>([]);
  const [store, setStore] = useState<'ONLINE' | 'OFFLINE' | undefined>(
    undefined,
  );
  const [keyword, setKeyword] = useState<string>('');

  useEffect(() => {

    getList();
  }, [page, store]);

  const getList = () => {
    const params = { keyword, store };
    setIsLoading(true);
    getOrderHistory(page, 10, params).then(r => {
      setOrders(r?.data.payload.content || []);
      setTotalPage(r?.data.payload.totalPages || 0);

    }).finally(() =>
      setIsLoading(false)
    );

  };

  return (
    <>
      <DirectoryBar text="전체 주문 내역" backArrow className="md:hidden" />
      <div className="py-4">
        <PopUp
          title="구매 확정"
          description="구매 확정 시 적립금이 즉시 지급 됩니다.
        단, 구매 확정 시에는 해당 제품은 교환 및 환불이 불가 하오니 참고부탁드립니다."
          buttonText="구매 확정하기"
          open={popup}
          onClose={() => setPopup(false)}
        />
        <H6 className="pb-4">전체 주문 내역</H6>
        <div className="flex md:flex-row flex-col md:justify-between">
          <MyPageStoreTabs onChange={type => setStore(type)} />
          <SearchField
            placeholder="검색하기"
            onChange={e => setKeyword(e.target.value)}
            onSearch={() => {
              setPage(0);
              getList();
            }}
          />
        </div>

        {orders.length === 0 ? (
          <div className={'py-20 center text-center'}>
            <p>{isLoading ? '주문 내역을 불러오는 중입니다.' : '주문 내역이 없습니다.'}</p>
          </div>
        ) : (
          <>
            <div className="">
              {orders.map((order, index) => (
                <div key={index} className="space-y-4 md:border-b py-6">
                  <div className="text-13 flex justify-between items-center">
                    <div className="flex md:space-x-10">
                      <div className="hidden space-x-2 md:flex">
                        <p className="text-gray-500">스토어명</p>
                        <p className="font-semibold">{order.store}</p>
                      </div>
                      <div className="hidden space-x-2 md:flex">
                        <p className="text-gray-500">주문일자</p>
                        <p className="font-semibold">
                          {moment(order.orderedAt).format(`YYYY.MM.DD`)}
                        </p>
                      </div>

                      <Link
                        to={`/mypage/orders/${order.orderNumber}`}
                        className="flex space-x-2 cursor-pointer">
                        <p className="text-gray-500">주문번호</p>
                        <p className="font-semibold">
                          {order.orderNumber} {`>`}
                        </p>
                      </Link>
                      <p className="md:hidden absolute right-4">
                        {moment(order.orderedAt).format(`YYYY.MM.DD`)}
                      </p>
                    </div>
                  </div>

                  <div className="h-px md:hidden bg-gray-200" />
                  <ProductItem order={order} />
                </div>
              ))}
            </div>

            <FrontPagination
              page={page}
              totalPages={totalPage}
              onPrevious={() => page !== 0 && setPage(page - 1)}
              onNext={() => page !== 10 && setPage(page + 1)}
              onNumClick={num => setPage(num - 1)}
            />
          </>
        )}
      </div>
    </>
  );
};

interface ProductItemProps {
  order: OrderSummary;
}

const ProductItem: FC<ProductItemProps> = ({ order }) => {
  return (
    <>
      {order.products.map((item, index) => (
        <div className="flex justify-between items-center" key={index}>
          <MProductCard
            thumbnail={item.thumbnailUrl}
            name={item.productName}
            color={item.color}
            content={
              <p className="text-13 text-brand-3">사이즈 {item.sizeName}</p>
            }
          />

          <div className="md:block text-right">
            <p className="font-bold">
              {swapProductShippingStatus(item.productStatus, item.latestRequestType, item.latestRequestStatus)}
              {/*{order.requestType && order.requestStatus*/}
              {/*  ? requestStatusCase(order.requestType, order.requestStatus)*/}
              {/*  : orderStatusCase(order.status!, order.shippingStatus!)}*/}
            </p>
            <p className="text-13">{item.latestRequestShippingCompany || (!item.latestRequestType && item.shippingCompany)}</p>
            <TrackingNumber shippingTrackingNumber={item.latestRequestShippingNumber || (!item.latestRequestType ? item.shippingNumber! : '')} />
          </div>
        </div>
      ))}
    </>
  );
};
